/* DEV NOTE: define the function getModelValues everytime we use this mixin. */
import _ from 'lodash';

export default {
	data() {
		return {
			initialFilterValues: {},
			filterValues: {}
		};
	},
	created() {
		this.initialFilterValues = _.cloneDeep(this.getModelValues());
		this.$emit('initialValuesUpdated', this.initialFilterValues);
	},
	mounted() {
		this.filterValues = this.getModelValues();
		this.$emit('filterValuesUpdated', this.filterValues);
	},
	updated() {
		this.filterValues = this.getModelValues();
		this.$emit('filterValuesUpdated', this.filterValues);
	}
};
